import { loadList } from '@/store/compositionV2/utils/data/actions'
import { isCheckedAll, toggleCheckedAll, toggleCheckedItem } from '@/utils/store/table'
import { refreshArr } from '@/utils/array/reactive'
import { showAlertError } from '@/utils/store/alert'

const createState = () => ({
  // url api который подставляется при запросах
  urlApi: '',
  api: null,
  list: [],
  currentItem: {},
  allItemsChecked: false
  // для шапки таблицы
  // tableHeaders: []
})

const createGetters = () => ({
  getCurrentItem: state => state.currentItem,
  getCurrentItemId: state => state.currentItem?.id || null,
  getAllItemsChecked: state => state.allItemsChecked,
  getTableHeaders: state => state.tableHeaders,
  visibleButtonRemoveItems: (state, getters) => {
    if (state.allItemsChecked) return true
    if (!getters.getList.length) return false

    return !!(getters.getList.findIndex(item => item.isActive) + 1)
  },
  visibleTable: (state) => state.list.length
  //   Преобразование данных для таблицы через геттер
  //   getList: state => {
  //   return state.list.map(item => {
  //     return {
  //       isControlsActive: item.isControlsActive,
  //       isActive: item.isActive,
  //       id: item.id,  //
  //       необходимо расположить данные в том порядке, в котором они должны быть представлены в таблице по колонкам
  //       values: [
  //         item.dateStart || '-',
  //         item.dateEnd || '-'
  //       ]
  //     }
  //   })
  // }
})

const createMutations = () => ({
  SET_LIST: (state, list) => {
    refreshArr(
      state.list,
      list.map(item => ({
        ...item,
        isControlsActive: false,
        isActive: false
      }))
    )
  },

  SET_CURRENT_ITEM: (state, payload) => {
    state.currentItem = payload
  },

  SET_ITEM_CHECKED: (state, itemId) => {
    state.list = [...toggleCheckedItem(itemId, state.list)]
    state.allItemsChecked = isCheckedAll(state.list)
  },

  SET_ALL_ITEMS_CHECKED: (state) => {
    state.allItemsChecked = !state.allItemsChecked
    state.list = toggleCheckedAll(state.allItemsChecked, state.list)
  }
})

const createActions = () => ({
  loadList,

  async loadOneItem ({ state, commit }, id) {
    try {
      commit('SET_IS_LOADING', true)

      const response = await state.api.getById(id, { expand: state.expand })

      commit('SET_CURRENT_ITEM', response.data.data)
    } catch (e) {
      showAlertError(e)
    } finally {
      commit('SET_IS_LOADING', false)
    }
  },

  async createItem ({ state, dispatch }, data) {
    return state.api.create(data)
  },

  async updateItem ({ state, dispatch, getters, commit }, data) {
    return state.api.update(getters.getCurrentItemId, data)
  },

  async deleteItems ({ state, commit, dispatch }) {
    try {
      await state.api.destroyList(state.list.filter(item => item.isActive))
    } finally {
      state.allItemsChecked = false
      commit('SET_CURRENT_PAGE', 1)
      await dispatch('loadList')
    }
  }
})

export const vuexDataBase = {
  createState,
  createGetters,
  createMutations,
  createActions
}
